import Segment from '@/creditflowresearch/domain/Segment/Segment';
import { MarketSegment } from '@/creditflowresearch/domain/Market/types/MarketSegment';
import { FIG_SEGMENT_ID } from '@/creditflowresearch/domain/Segment/constants';

class FigSegment extends Segment {
  static readonly SEGMENT_ID: string = FIG_SEGMENT_ID;

  static readonly TYPE: MarketSegment = MarketSegment.FIG;
}

export default FigSegment;
